module.exports = __webpack_public_path__ + "img/img_start.7d66558e.png";